import * as yup from "yup";

import { type Shape } from "@ds/utils/validation";

import { normalizeNanpPhoneDigits } from "./contacts-helpers";

const nameSchema = yup.string().required("Please specify location name");
const addressSchema = yup.object().shape<Shape<Address>>({
  country: yup.string().required("Please specify country"),
});
function toTrimmedString(value: unknown): string {
  if (value === null || typeof value === "undefined") {
    return "";
  }
  return String(value).trim();
}

/*
 * Details contacts card: each listed contact row must have name, email, and phone (trimmed).
 * Empty `contacts: []` is valid. Partial API rows still load into the form; in edit mode, `mode: "all"`
 * surfaces field errors until the user fixes or removes the row.
 */
const contactSchemaDetailsCard = yup.object({
  name: yup.string().transform(toTrimmedString).required("Please specify name"),
  email: yup
    .string()
    .transform(toTrimmedString)
    .required("Please specify email")
    .email("Please enter a valid email address"),
  phone: yup
    .string()
    /* Shared NANP digit normalization; strips leading 1 for 11-digit API/store values (masked input is 10-digit). */
    .transform(val => normalizeNanpPhoneDigits(toTrimmedString(val)))
    .required("Please specify a phone number")
    .matches(/^\d{10}$/, "Please enter a valid phone number"),
  title: yup.string().transform(toTrimmedString).optional().max(64, "Title must be less than 64 characters"),
});
const contactsSchemaDetailsCard = yup.array().of(contactSchemaDetailsCard).default([]);
const openHoursSchema = yup.array<LocalityOpeningHours>();

export const createValidationSchema = {
  step1: yup.object().shape<Shape<Locality>>({
    address: addressSchema,
  }),
  step2: yup.object().shape<Shape<Locality>>({
    open_hours: openHoursSchema,
  }),
  step3: yup.object().shape<Shape<Locality>>({
    name: nameSchema,
  }),
};

export const updateValidationSchema = {
  contacts: yup.object().shape<Shape<Locality>>({
    contacts: contactsSchemaDetailsCard,
  }),
  info: yup.object().shape<Shape<Locality>>({
    name: nameSchema,
  }),
  address: yup.object().shape<Shape<Locality>>({
    address: addressSchema,
  }),
  openHours: yup.object().shape<Shape<Locality>>({
    open_hours: openHoursSchema,
  }),
};
